import React, { useState } from "react";
import {
  Modal,
  ModalBody,
  ModalHeader,
  Input,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import usePersistStoreData from "../Hooks/usePersistStoreData";
import { Formik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";

const EditMaritalStatusModal = ({ edit_marital, close_editMarital }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData } = usePersistStoreData();
  const token = userData?.token;
  const FILE_SIZE = 2 * 1024 * 1024; // 2MB
  const SUPPORTED_FORMATS = ["application/pdf", "image/jpeg"];

  const initialValues = {
    user_marital_status: "",
    user_marital_document: "",
  };
  const validationSchema = Yup.object({
    user_marital_status: Yup.string()
  .required("Please select marital status"),

    user_marital_document: Yup.mixed()
      .required("Document is required")
      .test("fileType", "Only PDF or JPEG files are allowed", (value) => {
        return value && SUPPORTED_FORMATS.includes(value.type);
      })
      .test("fileSize", "File size must be less than 2 MB", (value) => {
        return value && value.size <= FILE_SIZE;
      }),
  });

  const statusOptions = [
    {key:"1", label:"Single"},
    {key:"2", label:"Married"},
    {key:"3", label:"Divorced"},
    {key:"4", label:"Widowed"},
    {key:"5", label:"Separated"},
  ]

  return (
    <Modal isOpen={edit_marital} centered={true} className="contact_modal_custom">
      <ModalHeader
        toggle={close_editMarital}
        style={{
          backgroundColor: "#0F528D",
          paddingTop: "0.75rem",
          paddingBottom: "0.75rem",
        }}
      >
        <span className="fs-16 contact_note_header ">Edit Marital Status</span>
      </ModalHeader>
      <ModalBody className="">
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log("Form values:", values);
            close_editMarital();
          }}
        >
          {(formik) => (
            <Form onSubmit={formik.handleSubmit}>
              <ModalBody className="p-0">
                <Row className="row m-0 p-0">
                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_marital_status">Marital Status *</Label>
                      <Input
                        type="select"
                        name="user_marital_status"
                        id="user_marital_status"
                        className="form-control"
                        placeholder="Enter name"
                        value={formik.values.user_marital_status}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.user_marital_status && !!formik.errors.user_marital_status
                        }
                      >
                        <option  value="" disabled>Select Option</option>
                        {statusOptions?.map((item,index) => (
                          <option value={item?.key} key={item?.key}>{item?.label}</option>
                        ))}
                         </Input>
                      
                      <FormFeedback>{formik.errors.user_marital_status}</FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col xxl={12} className="ps-0">
                    <FormGroup>
                      <Label for="user_marital_document">
                        Upload Documents-pdf, jpeg (Passport / Marriage Certificate) *
                      </Label>
                      <Input
                        type="file"
                        name="user_marital_document"
                        id="user_marital_document"
                        className="form-control"
                        accept="application/pdf, image/jpeg"
                        onChange={(e) => {
                          const file = e.currentTarget.files[0];
                          formik.setFieldValue("user_marital_document", file);
                        }}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.user_marital_document &&
                          formik.errors.user_marital_document
                        }
                      />

                      <FormFeedback>
                        {formik.errors.user_marital_document}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <div className="centerContent">
                <Button
                  className="fs-16"
                  color="primary"
                  type="submit"
                  style={{
                    minWidth: "120px",
                  }}
                >
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default EditMaritalStatusModal;
